import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { getTheme } from 'helpers'
import qs from 'qs'
import Cookies from 'js-cookie'

import HorizontalCentered from 'components/HorizontalCentered'
import VerticalCentered from 'components/VerticalCentered'
import svgLoading from 'assets/svg/icon-loading.svg'

@connect()
export default class extends Component {
  componentDidMount () {
    const { _token } = qs.parse(this.props.location.search.slice(1))
    Cookies.set('sbwshop-token', _token, { expires: 365 })
    window.location.href = '/'
  }

  render () {
    return (
      <Container>
        <HorizontalCentered>
          <VerticalCentered>
            <IconLoading alt='' src={svgLoading} />
          </VerticalCentered>
        </HorizontalCentered>
      </Container>
    )
  }
}

const Container = styled.section`
  background-color: ${getTheme`colorTiffany`};
`
const IconLoading = styled.img`
  width: 60px;
  height: 60px;
  display: block;
  filter: brightness(0) invert(1);
`



// WEBPACK FOOTER //
// ./src/containers/Authenticate.js